import React from "react";
import table_4_img from './table_4_seat.png'
import table_2_img from './table_2_seat.png'
import icon_img from './checked.png'
import {Modal} from 'react-spaceship-web';

export default class POSCrateBill extends React.Component {
	constructor() {
		super();
		this.state = {
			canvas_width: 1020,
			canvas_height: 500,
			is_select_obj: false,
			polygonMode: false,
			canvas_object: [],
		}
		this.POSCrateBillSetting = React.createRef();
	}

	componentDidMount() {
		// console.log(this.$parent.find('#canvas-frame').width());
		this.fetch();
	}

	fetch() {
		this.setState({

			canvas_object: [
				{
					title: 'โต๊ะ 1',
					type: 'table',
					table_type: '4-seats',
					top: 50,
					left: 50,
					seats: 4,
					arrived: false,
					id: 1,
				},
				{
					title: 'โต๊ะ 2',
					type: 'table',
					table_type: '2-seats',
					top: 50,
					left: 300,
					seats: 2,
					scaleX: 0.5,
					scaleY: 0.5,
					arrived: true,
					id: 2,
				},
				{
					title: 'โต๊ะ 3',
					type: 'table',
					table_type: '4-seats',
					top: 280,
					left: 350,
					seats: 3,
					arrived: true,
					id: 3,
				},
				{
					type: 'building_plan',
					points: [
						{x: 5, y: 5, canvas_obj_type: "polygon_base"},
						{x: 522, y: 9, canvas_obj_type: "polygon_base"},
						{x: 663, y: 491, canvas_obj_type: "polygon_base"},
						{x: 113, y: 491, canvas_obj_type: "polygon_base"}]
				}
			],
			canvas_width: this.$parent.find('#canvas-frame').width(),
		}, () => {
			this.createCanvas();
			this.POSCrateBillSetting.current.setTable(this.state.canvas_object)
		})
	}

	createBuildingPlan(points, options) {
		let canvas = this.__canvas;
		let polygon = new window.fabric.Polygon(points, {
			canvas_obj_type: 'building_plan',
			fill: '#ccc',
			// selectionBackgroundColor: '#ccc',
			opacity: options && options.opacity ? options.opacity : 0.3,
			// hasBorders: false,
			hasControls: false,
			draggable: false,
			lockMovementY: true,
			lockRotation: true,
			lockMovementX: true,
			lockScalingX: true,
			lockScalingY: true,
			lockSkewingX: true,
			lockSkewingY: true,
			lockUniScaling: true,
			// selectable: false,
			// evented: false,
			hoverCursor: 'default',
			hasRotatingPoint: false,
		});
		this.addCanvas(canvas, polygon, {
			send_to_back: true,
			removePoint: true,
			removePolygon: options && options.delete_new_object
		});
	}

	getObject(target) {
		let obj = {};
		if (target.left) {
			obj.left = parseFloat(target.left);
		}
		if (target.top) {
			obj.top = parseFloat(target.top);
		}
		if (target.translateY) {
			obj.translateY = parseFloat(target.translateY);
		}
		if (target.translateX) {
			obj.translateX = parseFloat(target.translateX);
		}
		if (target.scaleX) {
			obj.scaleX = parseFloat(target.scaleX);
		}
		if (target.scaleY) {
			obj.scaleY = parseFloat(target.scaleY);
		}
		if (target.zoomX) {
			obj.zoomX = parseFloat(target.zoomX);
		}
		if (target.zoomY) {
			obj.zoomY = parseFloat(target.zoomY);
		}
		if (target.canvas_obj_type) {
			obj.canvas_obj_type = target.canvas_obj_type;
		}
		if (target._objects) {
			target._objects.map((object) => {
				if (object.canvas_obj_type === 'group_detail') {
					object._objects.map((_object) => {
						if (_object.canvas_obj_type === 'Text') {
							obj.title = _object.text;
						}
						if (_object.table_type) {
							obj.table_type = _object.table_type;
						}
						if (_object.seats) {
							obj.seats = _object.seats;
						}
						return false;
					})
				}
				return false;
			});
		}
		return obj
	}

	Polygon(_polygonMode) {
		let min = 99;
		let max = 999999;
		let polygonMode = _polygonMode || true;
		let pointArray = [];
		let lineArray = [];
		let activeLine;
		let activeShape = false;
		let canvasActiveObj = false;
		let canvas = this.__canvas;
		let _this = this;
		let prototypefabric = new function () {
			this.initCanvas = () => {
				window.$('.cancel-create-polygon').click(() => {
					// let _confirm = window.confirm("Confirm GeneratePolygon");
					// if (!_confirm) {
					// 	return false;
					// }
					prototypefabric.polygon.generatePolygon(pointArray, {delete_new_object: true});
					// prototypefabric.polygon.setPointDefault();
				});
				canvas.on('mouse:down', function (options) {
					if (!polygonMode && canvas.getActiveObject()) {
						prototypefabric.polygon.setPointDefault();
						canvasActiveObj = canvas.getActiveObject();
					}
					if (polygonMode && options.target && options.target.id && pointArray.length > 0 && options.target.id === pointArray[0].id) {
						prototypefabric.polygon.generatePolygon(pointArray);
					}
					// options.target
					if (polygonMode) {
						prototypefabric.polygon.addPoint(options);
					}
				});
				canvas.on('mouse:up', function (options) {
					if (!polygonMode) {
						canvasActiveObj = false;
						prototypefabric.polygon.setPointDefault()
					}
				});

				canvas.on('mouse:move', function (options) {
					if (!polygonMode
						&& canvasActiveObj
						&& canvas.getActiveObject()
						&& canvas.getActiveObject().canvas_obj_type === 'point'
					) {
						canvasActiveObj.set("left", (options.e.layerX / canvas.getZoom()));
						canvasActiveObj.set("top", (options.e.layerY / canvas.getZoom()));
						let points_a = [];
						canvas.getObjects().forEach((obj) => {
							if (obj.canvas_obj_type === 'polygon') {
								canvas.remove(obj);
							}
							if (obj.canvas_obj_type === 'point') {
								points_a.push(obj);
							}
						});
						prototypefabric.polygon.generatePolygon(points_a);
					}
					if (activeLine && activeLine.class === "line") {
						let pointer = canvas.getPointer(options.e);
						activeLine.set({x2: pointer.x, y2: pointer.y, canvas_obj_type: 'preview-line'});
						let points = [];
						if (activeShape) {
							points = activeShape.get("points");
							points[pointArray.length] = {
								x: pointer.x,
								y: pointer.y
							};
							activeShape.set({
								points: points
							});
						}

						canvas.renderAll();
					}

					canvas.renderAll();
				});
				// window.document.onkeydown = function (e) {
				// 	var evtobj = window.event ? window.event : e;
				// 	if (evtobj.keyCode === 88 && !evtobj.ctrlKey) {
				// 		canvas.getObjects().forEach((obj) => {
				// 			if (obj.canvas_obj_type === 'point' || obj.canvas_obj_type === 'line') {
				// 				obj.set("opacity", 0);
				// 			}
				// 		});
				// 	}
				// 	if (evtobj.keyCode === 67 && !evtobj.ctrlKey) {
				// 		canvas.getObjects().forEach((obj) => {
				// 			if (obj.canvas_obj_type === 'point' || obj.canvas_obj_type === 'line') {
				// 				obj.set("opacity", 1);
				// 			}
				// 		});
				// 	}
				// 	if (evtobj.keyCode === 90 && evtobj.ctrlKey) {
				// 		pointArray.pop();
				// 		lineArray.pop();
				// 		if (activeShape) {
				// 			activeShape.points.pop();
				// 		}
				// 		activeLine = lineArray[lineArray.length - 1];
				// 		if (canvas.getObjects().length > 1) {
				// 			let get_point = [];
				// 			let preview_line = [];
				// 			canvas.getObjects().forEach((obj, obj_i) => {
				// 				if (obj.canvas_obj_type === 'preview-line') {
				// 					preview_line.push(obj);
				// 				}
				// 				if (obj.canvas_obj_type === 'point') {
				// 					get_point.push(obj);
				// 				}
				// 			});
				// 			canvas.remove(get_point[get_point.length - 1]);
				// 			canvas.remove(preview_line[preview_line.length - 1]);
				// 		}
				// 		// canvas.renderAll();
				//
				// 	}
				// };
			};
		}();

		prototypefabric.polygon = {
			drawPolygon: function () {
				polygonMode = true;
				pointArray = [];
				lineArray = [];
				activeLine = false;
			},
			addPoint: function (options) {
				let left = 0;
				let top = 0;
				let custom_options = {};
				if (options && options.add_by_point) {
					left = options.x;
					top = options.y;
					custom_options.left = left;
					custom_options.top = top;
				}
				if (options && !options.add_by_point) {
					left = (options.e.layerX / canvas.getZoom());
					top = (options.e.layerY / canvas.getZoom());
					custom_options.left = left;
					custom_options.top = top;
				}

				let random = Math.floor(Math.random() * (max - min + 1)) + min;
				let id = new Date().getTime() + random;
				let circle = new window.fabric.Circle({
					...custom_options,
					radius: options && options.add_by_point ? 1 : 2,
					fill: '#ffffff',
					stroke: '#333333',
					strokeWidth: 0.5,
					opacity: 0.3,
					left: left,
					top: top,
					// selectable: false,
					hasBorders: false,
					hasControls: false,
					originX: 'center',
					originY: 'center',
					id: id,
					objectCaching: false,
					cursorStyle: 'default',
					canvas_obj_type: 'point'
				});
				if (pointArray.length === 0) {
					circle.set({
						cursorStyle: 'pointer',
						fill: 'red',
						opacity: 0.3,
					})
				}
				let points = [(left / canvas.getZoom()), (top / canvas.getZoom()), (left / canvas.getZoom()), (top / canvas.getZoom())];
				let line = new window.fabric.Line(points, {
					strokeWidth: 1,
					fill: 'back',
					stroke: 'back',
					class: 'line',
					opacity: 0.5,
					originX: 'center',
					originY: 'center',
					selectable: false,
					hasBorders: false,
					hasControls: false,
					evented: false,
					objectCaching: false,
					canvas_obj_type: 'selected-line'
				});
				if (activeShape) {
					let pos = canvas.getPointer(options.e);
					let points = activeShape.get("points");
					points.push({
						x: pos.x,
						y: pos.y
					});
					let polygon = new window.fabric.Polygon(points, {
						stroke: '#333333',
						strokeWidth: 1,
						fill: '#cccccc',
						opacity: 0.1,
						selectable: false,
						hasBorders: false,
						hasControls: false,
						evented: false,
						objectCaching: false
					});
					canvas.remove(activeShape);
					canvas.add(polygon);
					activeShape = polygon;
					canvas.renderAll();
				} else {
					let polyPoint = [{
						x: (left / canvas.getZoom()),
						y: (top / canvas.getZoom())
					}];
					let polygon = new window.fabric.Polygon(polyPoint, {
						stroke: '#333333',
						strokeWidth: 1,
						fill: '#cccccc',
						opacity: 0.3,
						selectable: false,
						hasBorders: false,
						hasControls: false,
						evented: false,
						objectCaching: false
					});
					activeShape = polygon;
					canvas.add(polygon);
				}
				activeLine = line;

				pointArray.push(circle);
				lineArray.push(line);

				canvas.add(line);
				canvas.add(circle);
				canvas.selection = false;
				if (options.add_by_point) {
					let points_a = [];
					canvas.getObjects().forEach((obj) => {
						if (obj.canvas_obj_type === 'polygon') {
							canvas.remove(obj);
						}
						if (obj.canvas_obj_type === 'point') {
							points_a.push(obj);
						}
					});

					prototypefabric.polygon.generatePolygon(points_a, {opacity: options.opacity});
				}
			},
			generatePolygon: function (pointArray, options) {
				let points = [];
				window.$.each(pointArray, function (index, point) {
					points.push({
						x: point.left,
						y: point.top,
						canvas_obj_type: 'polygon_base',
					});
					// canvas.remove(point);
				});
				window.$.each(lineArray, function (index, line) {
					canvas.remove(line);
				});
				canvas.remove(activeShape).remove(activeLine);
				let polygon = new window.fabric.Polygon(points, {
					canvas_obj_type: 'building_plan',
					fill: '#ccc',
					// selectionBackgroundColor: '#ccc',
					opacity: options && options.opacity ? options.opacity : 0.3,
					// hasBorders: false,
					hasControls: false,
					draggable: false,
					lockMovementY: true,
					lockRotation: true,
					lockMovementX: true,
					lockScalingX: true,
					lockScalingY: true,
					lockSkewingX: true,
					lockSkewingY: true,
					lockUniScaling: true,
					// selectable: false,
					// evented: false,
					hasRotatingPoint: false,
				});
				let create_obj = {
					points: points,
					canvas_obj_type: "building_plan"
				}
				_this.create(create_obj, {
					onSuccess: () => {
						_this.addCanvas(canvas, polygon, {
							send_to_back: true,
							removePoint: true,
							removePolygon: options && options.delete_new_object
						});
					}
				});
				_this.POSCrateBillSetting.current.successCreateBill();
				activeLine = null;
				activeShape = null;
				polygonMode = false;
			},
			setPointDefault: () => {
				canvas.getObjects().forEach((obj) => {
					if (obj.canvas_obj_type === 'point') {
						obj.set("fill", "#555");
						obj.set("opacity", 1);
						obj.bringToFront();
					}
				});
			}
		};
		prototypefabric.initCanvas();
		prototypefabric.polygon.drawPolygon();
		return prototypefabric;
	}

	createCanvas() {
		this.__canvas = new window.fabric.Canvas(window.$('#canvas').get(0), {
			preserveObjectStacking: true,
		});


		for (let i = 0; i < this.state.canvas_object.length; i++) {
			if (this.state.canvas_object[i].type === 'table') {
				this.addTable(this.state.canvas_object[i], {active_object: false});
			}
			if (this.state.canvas_object[i].type === 'building_plan') {
				this.createBuildingPlan(this.state.canvas_object[i].points);
			}
		}

		let canvas = this.__canvas;
		canvas.off('mouse:up').on('mouse:up', (e) => {
			// console.log('mouse:up');
			// อัพเดทข้อมูล Text
			if (e.target) {
				let obj = this.getObject(e.target);
				if (e.target.canvas_obj_type !== "point" && obj.canvas_obj_type !== 'building_plan') {
					this.update(obj);
				}
				this.POSCrateBillSetting.current.objectSelected(obj);
			}
		});
		canvas.off("object:moving").on("object:moving", function (e) {
			let obj = e.target;
			// if object is too big ignore asdasd
			if (obj.currentHeight > obj.canvas.height || obj.currentWidth > obj.canvas.width) {
				return;
			}
			obj.setCoords();

			let maxTop = 0; //ระยะห่างจากขอบด้านบน
			let maxLeft = 0; //ระยะห่างจากขอบด้านซ้าย
			let maxBottom = 50; //ระยะห่างจากขอบด้านล่าง
			let maxRight = 118; //ระยะห่างจากขอบด้านขวา


			// console.log(obj.getBoundingRect());
			// top-left  corner
			let offset = 20;
			if (obj.getBoundingRect().top < maxTop) {
				obj.top = maxTop + offset;
			}
			if (obj.getBoundingRect().left < maxLeft) {
				obj.left = maxLeft + offset;
			}
			if (obj.getBoundingRect().top > (obj.canvas.height - maxBottom) - obj.getBoundingRect().height) {
				obj.top = Math.min(obj.top, obj.canvas.height - obj.getBoundingRect().height + obj.top - obj.getBoundingRect().top) - offset;
			}
			// bot-right corner
			if (obj.getBoundingRect().left > (obj.canvas.width - maxRight) - obj.getBoundingRect().width) {
				obj.left = Math.min(obj.left, obj.canvas.width - obj.getBoundingRect().width + obj.left - obj.getBoundingRect().left) - offset;
			}
		});
		canvas.off('object:scaling').on('object:scaling', (e) => {
			let obj = e.transform.target;
			// let max = 1;
			// let min = 0.5;
			// if (obj.scaleX && obj.scaleX > max) {
			// 	obj.scaleX = max;
			// }
			// if (obj.scaleY && obj.scaleY > max) {
			// 	obj.scaleY = max;
			// }
			// if (obj.scaleX && obj.scaleX < min) {
			// 	obj.scaleX = min;
			// }
			// if (obj.scaleY && obj.scaleY < min) {
			// 	obj.scaleY = min;
			// }
			this.POSCrateBillSetting.current.objectSelected(obj);
		});
		canvas.off('selection:cleared').on('selection:cleared', (e) => {
			this.POSCrateBillSetting.current.clearSelected();
		});
		canvas.off('selection:created').on('selection:created', (e) => {
			// console.log(e);
			if (e.selected.length > 0) {
				let obj = this.getObject(e.selected[0]);
				this.POSCrateBillSetting.current.objectSelected(obj);
			}
		});

		this.canvasHeight();
	}

	addTable(obj, object) {
		let active_object = true;
		if (object && object.active_object !== undefined) {
			active_object = object.active_object;
		}
		obj.arrived = true;
		let canvas = this.__canvas;
		let text = new window.fabric.Text(obj.title + '', {
			fontSize: 30,
			originX: 'center',
			originY: 'center',
			// backgroundColor: 'green',
			fontFamily: "Kanit",
			canvas_obj_type: 'Text',
			table_type: obj.table_type,
			seats: obj.seats,
			// color: '#fff',
			fill: '#000',
			padding: 5,
			selectable: false,
		});
		let details_group = new window.fabric.Group([text], {
			left: 0,
			top: 0,
			canvas_obj_type: 'group_detail',
			width: 260,
			height: 260,
			hasRotatingPoint: false,
			lockUniScaling: true,
			lockSkewingX: true,
			lockSkewingY: true,
			lockRotation: true,
		});
		window.fabric.Object.prototype.transparentCorners = false;
		window.fabric.Object.prototype.cornerColor = 'rgba(0,0,0,1)';
		window.fabric.Object.prototype.cornerStyle = 'circle';
		window.fabric.Object.prototype.borderColor = '#ccc';
		window.fabric.Object.prototype.hasControls = true;


		// จำนวนที่นั่ง
		let person = new window.fabric.Text(obj.seats + " คน", {
			fontSize: 18,
			left: 85,
			top: 80,
			fontFamily: "Kanit",
			canvas_obj_type: 'seats',
			fill: '#000',
			selectable: false,
		});

		let arrived = false;
		// ถ้ามีคนนั่งแล้ว
		if (obj.arrived) {
			window.fabric.Image.fromURL(icon_img, (_icon_img) => {
				_icon_img.set({
					canvas_obj_type: 'icon_image',
					left: 160,
					top: 80,
				})
				_icon_img.scaleToWidth(20);
				arrived = _icon_img;
			});
		}

		let table_img = table_4_img;
		if (obj.table_type === '2-seats') {
			table_img = table_2_img;
		}

		window.fabric.Image.fromURL(table_img, (_table_img) => {
			_table_img.set({
				canvas_obj_type: 'table_image',
				left: 22,
				top: 22,
				table_type: obj.table_type,
			})
			_table_img.scale(0.6);
			let group_array = [_table_img, details_group, person]
			if (arrived) {
				group_array.push(arrived)
			}

			let group_obj = {
				left: parseFloat(obj.left) || 50,
				top: parseFloat(obj.top) || 50,
				canvas_obj_type: 'table',
				width: 200,
				height: 200,
				hasRotatingPoint: false,
				lockUniScaling: true,
				// lockScalingX: true,
				// lockScalingY: true,
				lockSkewingX: true,
				lockSkewingY: true,
				lockRotation: true,
				// transparentCorners: true,
			}
			if (obj.scaleY) {
				group_obj.scaleY = parseFloat(obj.scaleY);
			}
			if (obj.scaleX) {
				group_obj.scaleX = parseFloat(obj.scaleX);
			}
			if (obj.translateY) {
				group_obj.translateY = parseFloat(obj.translateY);
			}
			if (obj.translateX) {
				group_obj.translateX = parseFloat(obj.translateX);
			}
			if (obj.zoomY) {
				group_obj.zoomY = parseFloat(obj.zoomY);
			}
			if (obj.zoomX) {
				group_obj.zoomX = parseFloat(obj.zoomX);
			}

			let group = new window.fabric.Group(group_array, group_obj);
			group.setControlsVisibility({mtr: false});
			this.addCanvas(canvas, group, {
				active_object: active_object,
			})

		});

		// canvas.renderAll();
	}


	addCanvas(canvas, object, options) {
		canvas.add(object);
		if (options && options.active_object) {
			canvas.setActiveObject(object);
		}
		if (options && options.send_to_back) {
			canvas.sendToBack(object);
		}
		if (options && options.bring_to_front) {
			canvas.bringToFront(object);
		}
		if (options && options.onSuccess) {
			options.onSuccess(canvas.getActiveObject());
		}
		let obj = canvas.getObjects();
		if (options && options.removePoint) {
			for (let i in obj) {
				if (obj[i].canvas_obj_type === 'point') {
					canvas.remove(obj[i]);
				}
			}
		}
		if (options && options.removePolygon) {
			let _building_plan_obj = [];
			for (let i in obj) {
				if (obj[i].canvas_obj_type === 'building_plan') {
					_building_plan_obj.push(obj[i]);
				}
			}
			canvas.remove(_building_plan_obj[0]);

		}
		// console.log(canvas.getObjects());

	}

	create(obj, options) {
		if (obj && !obj.left) {
			obj.left = 50;
		}
		if (obj && !obj.top) {
			obj.top = 50;
		}
		if (obj && !obj.scaleX) {
			obj.scaleX = 1;
		}
		if (obj && !obj.scaleY) {
			obj.scaleY = 1;
		}
		if (obj && !obj.translateX) {
			obj.translateX = 150;
		}
		if (obj && !obj.translateY) {
			obj.translateY = 150;
		}
		if (obj && !obj.zoomX) {
			obj.zoomX = 1;
		}
		if (obj && !obj.zoomY) {
			obj.zoomY = 1;
		}
		console.log("call Create Function");
		// console.log(obj);
		if (options && options.onSuccess) {
			options.onSuccess()
		}
	}

	update(obj, options) {
		console.log("call Update Function");
		// console.log(obj);
		if (options && options.onSuccess) {
			options.onSuccess()
		}
	}

	delete(obj, options) {
		console.log("call Delete Function");
		// console.log(obj);
		if (options && options.onSuccess) {
			options.onSuccess()
		}
	}


	canvasHeight() {
		// const panel = document.getElementById("canvas-frame");
		let canvas = this.__canvas;
		let m_pos;

		var resize_el = document.getElementById("canvas-frame-resize");

		function resize(e) {
			var parent = resize_el.parentNode;
			let offset = e.y - e.offsetY;
			m_pos = e.y - offset;
			if (parseInt(m_pos) < 500) {
				m_pos = 500
			}
			parent.style.height = parseInt(m_pos) + "px";
			canvas.setHeight(m_pos);
			// console.log(m_pos);
		}

		resize_el.addEventListener("mousedown", function (e) {
			m_pos = e.y;
			if (parseInt(m_pos) > 500) {
				document.addEventListener("mousemove", resize, false);
			}
		}, false);

		document.addEventListener("mouseup", function () {
			document.removeEventListener("mousemove", resize, false);
		}, false);
	}

	render() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container">
				{/*HEADER*/}
				<div id="HeaderTop_root" className="flex row wrap" style={{marginBottom: '1rem'}}>
					<div className="flex row middle-xs center-xs">
						<div className="ui huge breadcrumb" style={{margin: '0 1em 0 0'}}>
							<div className="active section">สร้างบิล</div>
						</div>
					</div>
				</div>

				<div className={"flex row padded"}>
					<div className={"col-xs-16 col-lg-11 padded"}>
						{/*<button onClick={() => {*/}
						{/*	console.log(this.__canvas.getObjects());*/}
						{/*}}>*/}
						{/*	LOG Objects*/}
						{/*</button>*/}
						<div className={"ui segment"}>
							<div id={"canvas-frame"}>
								<canvas id="canvas" width={this.state.canvas_width}
								        height={this.state.canvas_height}
								        style={{border: '1px solid #f4f4f4'}}
								/>
								<div id={"canvas-frame-resize"}/>
							</div>
						</div>
					</div>
					<div className={"col-xs-16 col-lg-4 padded"}>
						<POSCrateBillSetting
							ref={this.POSCrateBillSetting}
							createPolygon={() => {
								this.Polygon();
							}}
							cancelCreatePolygon={() => {
								this.Polygon(false);
							}}
							addTable={(obj) => {
								this.create(obj, {
									onSuccess: () => {
										this.addTable(obj);
									}
								});

							}}
							updateTable={(obj) => {
								// console.log(this.__canvas.getActiveObject());
								this.update(obj, {
									onSuccess: () => {
										let active_obj = this.__canvas.getActiveObject();
										if (active_obj.top !== obj.top) {
											active_obj.set("top", obj.top);
										}
										if (active_obj.left !== obj.left) {
											active_obj.set("left", obj.left);
										}
										if (active_obj.translateY !== obj.translateY) {
											active_obj.set("translateY", obj.translateY);
										}
										if (active_obj.translateX !== obj.translateX) {
											active_obj.set("translateX", obj.translateX);
										}
										if (active_obj.scaleY !== obj.scaleY) {
											active_obj.set("scaleY", obj.scaleY);
										}
										if (active_obj.scaleX !== obj.scaleX) {
											active_obj.set("scaleX", obj.scaleX);
										}
										active_obj._objects.map((object, object_i) => {
											if (object.canvas_obj_type === 'group_detail') {
												// console.log(object);
												object._objects.map((_object, _object_i) => {
													if (_object.canvas_obj_type === 'Text'
														&& _object.text !== obj.title) {
														// console.log(_object);
														active_obj._objects[object_i]._objects[_object_i].set("text", obj.title);
													}
													return true;
												})
											}
											if (object.canvas_obj_type === 'seats'
												&& active_obj._objects[object_i].seats !== obj.seats) {
												active_obj._objects[object_i].set("text", obj.seats + ' คน');
											}
											if (object.canvas_obj_type === "table_image"
												&& active_obj._objects[object_i].table_type !== obj.table_type) {
												// let table_img = table_4_img;
												// if (obj.table_type === '2-seats') {
												// 	table_img = table_2_img;
												// }
												// active_obj._objects[object_i].setSrc(table_img);
												this.__canvas.remove(active_obj)
												this.addTable(obj);
											}
											return true;
										})
										// return;
										this.__canvas.renderAll();
									}
								})

							}}
							removeObject={() => {
								// console.log(this.__canvas.getActiveObject());
								let active_obj = this.__canvas.getActiveObject();
								let obj = this.getObject(active_obj);
								this.delete(obj, {
									onSuccess: () => {
										this.__canvas.remove(active_obj);
									}
								})
							}}
						/>
					</div>
				</div>
			</div>
		)
	}
}

class POSCrateBillSetting extends React.Component {
	constructor() {
		super();
		this.state = {
			table: [],
			select_object: false,
		}
	}

	setTable(objects) {
		objects = objects.filter((e) => e.type === 'table');
		this.setState({
			table: objects,
		})
	}

	clearSelected() {
		this.setState({
			select_object: false,
			is_select_object: false,
		})
	}

	successCreateBill() {
		this.setState({
			is_create_polygon: false
		})
	}

	objectSelected(object) {
		object.top = parseFloat(object.top);
		object.left = parseFloat(object.left);
		if (object.translateY) {
			object.translateY = parseFloat(object.translateY);
		}
		if (object.translateX) {
			object.translateX = parseFloat(object.translateX);
		}
		if (object.scaleX) {
			object.scaleX = parseFloat(object.scaleX);
		}
		if (object.scaleY) {
			object.scaleY = parseFloat(object.scaleY);
		}
		if (object.zoomX) {
			object.zoomX = parseFloat(object.zoomX);
		}
		if (object.zoomY) {
			object.zoomY = parseFloat(object.zoomY);
		}
		this.setState({
			select_object: object,
			is_select_object: true,
		}, () => {
			this.$form.find('input[name="title"]').val(this.state.select_object.title);
			this.$form.find('input[name="seats"]').val(this.state.select_object.seats);
		})
	}

	onChangeTriggerSubmit() {
		clearTimeout(this.settimeout);
		this.settimeout = setTimeout(() => {
			this.$form.find('[type="submit"]').trigger('click');
		}, 1000)
	}

	render() {
		this.settimeout = false;
		return (
			<>
				{
					!this.state.is_create_polygon ?
						<>
							<button className={"ui button fluid"}
							        onClick={() => {

								        this.setState({
									        is_create_polygon: true,
								        }, () => {
									        this.props.createPolygon();
								        })
							        }}
							        style={{marginBottom: 15}}
							>
								เพิ่มแบบแปลน
							</button>
							<button className={"ui button fluid"}
							        onClick={() => {
								        // this.addCircle();
								        window.Global.reactToDom(window.$('body'),
									        <POSCrateBillAddModal
										        table={this.state.table}
										        onSuccess={(obj) => {
											        let table = [...this.state.table];
											        //let obj = {title: 'โต๊ะ ' + (table.length + 1)};
											        table.push(obj)
											        this.setState({
												        table: table,
												        select_object: obj,
												        is_select_object: true
											        }, () => {
												        this.props.addTable(obj);
											        })
										        }}
									        />
								        );

							        }}
							>
								เพิ่ม
							</button>
						</>
						:

						<button className={"ui button fluid cancel-create-polygon"}
						        onClick={() => {
							        this.setState({
								        is_create_polygon: false,
							        })
						        }}
						        style={{marginBottom: 15}}
						>
							ยกเลิก
						</button>
				}
				{
					this.state.select_object
					&& !this.state.is_create_polygon
					&& this.state.select_object.canvas_obj_type
					&& this.state.select_object.canvas_obj_type === 'table' ?
						<div className={"ui segment"}>
							<form className={"ui form"}
							      ref={(ref) => {
								      this.$form = window.$(ref);
							      }}
							      onSubmit={(e) => {
								      e.preventDefault();
								      let obj = {};
								      this.$form.serializeArray().forEach((item) => {
									      obj[item.name] = item.value;
								      })
								      obj.top = parseFloat(obj.top);
								      obj.left = parseFloat(obj.left);
								      this.props.updateTable(obj);
							      }}
							>
								<div className="field">
									<label>ชื่อโต๊ะ</label>
									<input type={"text"}
									       name={"title"}
									       defaultValue={this.state.select_object.title || ''}
									       onChange={(e) => {
										       this.onChangeTriggerSubmit()
									       }}
									/>
								</div>
								<div className="field">
									<label>จำนวนคนนั่ง</label>
									<div className="ui right labeled input">
										<label htmlFor="amount" className="ui basic label"
										       style={{cursor: 'pointer'}}
										       onClick={() => {
											       let amount = parseFloat(this.$form.find('input[name="seats"]').val());
											       amount = amount - 1;
											       if (!amount || amount < 0) {
												       amount = 0
											       }
											       this.$form.find('input[name="seats"]').val(amount);
											       this.onChangeTriggerSubmit()
										       }}
										>-</label>

										<input type={"number"} name={"seats"}
										       defaultValue={this.state.select_object.seats || ''}
										       onChange={(e) => {
											       this.onChangeTriggerSubmit()
										       }}
										/>
										<div className="ui basic label"
										     style={{cursor: 'pointer'}}
										     onClick={() => {
											     let amount = parseFloat(this.$form.find('input[name="seats"]').val());
											     if (!amount) {
												     amount = 0
											     }
											     amount = amount + 1;
											     this.$form.find('input[name="seats"]').val(amount);
											     this.onChangeTriggerSubmit()
										     }}
										>+
										</div>
									</div>
								</div>
								<div className={"field"}>
									<label>รูปแบบโต๊ะ</label>
									<div className="ui fluid selection dropdown"
									     ref={(ref) => {
										     window.$(ref).dropdown({
											     onChange: () => {
												     this.$form.find('[type="submit"]').trigger('click');
											     }
										     })
									     }}
									>
										<input type="hidden" name="table_type"
										       defaultValue={this.state.select_object.table_type}/>
										<i className="dropdown icon"/>
										<div className="default text">เลือกรูปแบบโต๊ะ</div>
										<div className="menu">
											<div className="item" data-value={"4-seats"}>
												<img className="ui mini avatar image" src={table_4_img}
												     alt={"canvasImg"}/>
												4 ที่นั่ง
											</div>
											<div className="item" data-value={"2-seats"}>
												<img className="ui mini avatar image"
												     src={table_2_img} alt={"canvasImg"}/>
												2 ที่นั่ง
											</div>
										</div>
									</div>
								</div>
								<input type={"hidden"} name={"left"} value={this.state.select_object.left || 0}/>
								<input type={"hidden"} name={"top"} value={this.state.select_object.top || 0}/>
								{
									this.state.select_object.translateY ?
										<input type={"hidden"} name={"translateY"}
										       value={this.state.select_object.translateY || 0}/>
										: null
								}
								{
									this.state.select_object.translateX ?
										<input type={"hidden"} name={"translateX"}
										       value={this.state.select_object.translateX || 0}/>
										: null
								}
								{
									this.state.select_object.scaleX ?
										<input type={"hidden"} name={"scaleX"}
										       value={this.state.select_object.scaleX || 0}/>
										: null
								}
								{
									this.state.select_object.scaleY ?
										<input type={"hidden"} name={"scaleY"}
										       value={this.state.select_object.scaleY || 0}/>
										: null
								}
								<div className="ui divider"/>
								<div className={"flex row"}>
									<button className={"ui button red"}
									        type={"button"}
									        onClick={() => {

										        this.props.removeObject();

									        }}
									>
										ลบ
									</button>
									<button className={"ui button blue right floated"}
									        type={"submit"}
									        onClick={() => {
										        // console.log(this.state.select_object);
									        }}
									>
										แก้ไข
									</button>
								</div>
							</form>
						</div>
						: null
				}
				{
					this.state.select_object
					&& this.state.select_object.canvas_obj_type
					&& this.state.select_object.canvas_obj_type === 'building_plan' ?
						<div className={"ui segment"}>
							<div className={"flex row"}>
								<button className={"ui button red"}
								        type={"button"}
								        onClick={() => {
									        console.log(this.state.table);
									        this.props.removeObject();

								        }}
								>
									ลบ
								</button>
							</div>
						</div>
						: null
				}

			</>
		);
		// return null;
	}
}

class POSCrateBillAddModal extends React.Component {
	render() {
		return (
			<div>
				<Modal
					className={"ui mini modal"}
					onShow={(ref) => {
						this.$modal = window.$(ref);
					}}
					onApprove={() => {
						let obj = this.$form.serializeObject();
						// console.log(obj);
						this.props.onSuccess(obj);
						this.$modal.modal('hide');
					}}
					closable={false}
					onDeny={() => {

					}}
					onHide={() => {

					}}
				>
					<div className="header">เพิ่มโต๊ะ</div>
					<div className="content">
						<form ref={e => {
							this.$form = window.$(e);
							this.$form.find('.ui.dropdown').dropdown();
						}}
						      className="ui form"
						>
							<div className={"field"}>
								<label>ชื่อโต๊ะ</label>
								<input type={"text"} name={"title"}
								       defaultValue={'โต๊ะ ' + (this.props.table.length + 1)}/>
							</div>
							<div className={"field"}>
								<label>จำนวนคนนั่ง</label>
								<div className="ui right labeled input">
									<label htmlFor="amount" className="ui basic label"
									       style={{cursor: 'pointer'}}
									       onClick={() => {
										       let amount = parseFloat(this.$form.find('input[name="seats"]').val());
										       amount = amount - 1;
										       if (!amount || amount < 0) {
											       amount = 0
										       }
										       this.$form.find('input[name="seats"]').val(amount)
									       }}
									>-</label>
									<input type={"number"} name={"seats"}
									       defaultValue={0}/>
									<div className="ui basic label"
									     style={{cursor: 'pointer'}}
									     onClick={() => {
										     let amount = parseFloat(this.$form.find('input[name="seats"]').val());
										     if (!amount) {
											     amount = 0
										     }
										     amount = amount + 1;
										     this.$form.find('input[name="seats"]').val(amount)
									     }}
									>+
									</div>
								</div>
							</div>
							<div className={"field"}>
								<label>รูปแบบโต๊ะ</label>
								<div className="ui fluid selection dropdown">
									<input type="hidden" name="table_type"/>
									<i className="dropdown icon"/>
									<div className="default text">เลือกรูปแบบโต๊ะ</div>
									<div className="menu">
										<div className="item" data-value={"4-seats"}>
											<img className="ui mini avatar image" src={table_4_img} alt={"canvasImg"}/>
											4 ที่นั่ง
										</div>
										<div className="item" data-value={"2-seats"}>
											<img className="ui mini avatar image"
											     alt={"canvasImg"}
											     src={table_2_img}/>
											2 ที่นั่ง
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
					<div className="actions">
						<button type={"button"} className={"ui button deny"}>ยกเลิก</button>
						<button type={"button"} className={"ui button blue approve"}>เพิ่ม</button>
					</div>
				</Modal>
			</div>
		);
	}
}